import React, { useEffect, useState } from 'react'
import { Button, Input, Modal, notification, Tabs, Space, Form } from 'antd'
import styled from 'styled-components'
import ReactPlayer from 'react-player'
import { VideoDetailSection } from './details-modal'
import { CommentsList } from './comments'
import { ThumbsUp, Eye, ChatCircleText } from 'phosphor-react'
import { UserAvatarWithName } from 'components'
import { DateFormat, DateUtility, VideosService } from 'utility'
import { BoldSpan, StatsContainer, StatWrapper } from './stats'
import { DotSeparator } from './details'
import { StackPlus } from '@phosphor-icons/react'
import { StyledCloseIcon } from 'components/StyleCloseIcon'

const FooterButtons = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`

const FullWidthButton = styled(Button)`
  flex: 1;
  height: 45px;
  font-weight: bold;

  &:nth-child(1) {
    background-color: #ffecec;
    color: #d32f2f;

    &:hover {
      background-color: #ffd6d6;
    }
  }

  &:nth-child(2) {
    background-color: #e8edff;
    color: #0056e0;
    border-color: #d6e0ff;

    &:hover {
      background-color: #d6e0ff;
    }
  }
`
const DetailText = styled.div`
  display: flex;

  span {
    font-size: 12px;
    font-weight: 600;
    color: #808080;
  }
`
const { TabPane } = Tabs

const StyledModal = styled(Modal)`
  background: #f5f7ff;

  .ant-modal-content {
    padding: 0 !important;
    background: #f5f7ff;
  }
`

const Container = styled.div`
  display: flex;
  height: 500px;
  padding: 20px;
  overflow: hidden;
`

const VideoSection = styled.div`
  width: 50%;

  @media (max-width: 1440px) {
    width: 50%;
  }
  .video-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 3% !important;
    overflow: hidden;
  }

  video {
    border-radius: 3%;
  }
`

const DetailsSection = styled.div`
  width: 50%;
  background: #f5f7ff;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`

const TabsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
`
const CommentsContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin !important;
  scrollbar-color: #b0b0b0 transparent;

  &::-webkit-scrollbar {
    width: 2px !important;
    min-width: 2px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 10px !important;
  }
`

export const VideoModal = ({ visible, onClose, item }) => {
  return (
    <StyledModal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      centered
      closeIcon={<StyledCloseIcon>✖</StyledCloseIcon>}
      style={{ borderRadius: '12px' }}
    >
      <Container>
        <VideoSection className="">
          <div className="video-wrapper">
            <ReactPlayer
              url={item?.video_url}
              controls
              playing
              width="100%"
              height=""
              type="video/mp4"
            />
          </div>
        </VideoSection>
        <DetailsSection>
          <TabsContainer>
            <Tabs defaultActiveKey="1" className="custom-tabs" centered>
              <TabPane tab="Details" key="1">
                <TabContent>
                  <VideoDetailSection item={item} />
                </TabContent>
              </TabPane>
              <TabPane tab="Comments" key="2">
                <TabContent>
                  <CommentsContainer>
                    <CommentsList id={item._id} />
                  </CommentsContainer>
                </TabContent>
              </TabPane>
            </Tabs>
          </TabsContainer>
        </DetailsSection>
      </Container>
    </StyledModal>
  )
}

const ReviewStyledModal = styled(Modal)`
  .ant-modal {
    max-height: 80vh;
    top: 10vh;
  }
  .ant-modal-body {
    height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;
  }
  &.normal-height-modal {
    .ant-modal-body {
      height: auto !important;
      max-height: 80vh;
    }
  }
  .ant-modal-body::-webkit-scrollbar {
    width: 6px;
  }

  .ant-modal-body::-webkit-scrollbar-thumb {
    background-color: #b0b0b0;
    border-radius: 3px;
  }

  .ant-modal-body::-webkit-scrollbar-track {
    background: #f0f0f0;
  }
  .ant-modal-header {
    padding: 15px;
    padding-bottom: 13px;
    ${'' /* padding: 16px; */}
    border-bottom: 1px solid #e5e5e5;
  }
  .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
  }
  .ant-modal-content {
    padding: 0;
  }
  .ant-modal-body {
    ${'' /* padding: 24px; */}
  }
  .ant-modal-footer {
    display: flex;
    margin-top: 0;
    justify-content: space-between;
    padding: 20px;
  }
  .video-info {
    margin-bottom: 2px;
  }
  .video-title {
    font-size: 18px;
    font-weight: bold;
  }
  .creator {
    margin-top: 8px;
    font-weight: bold;
  }
  .report-info {
    margin-top: 16px;
    padding: 12px;
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-radius: 5px;
  }
  .comment-box {
    // margin-top: 16px;
  }
  .footer-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
`
const VideoSelectionMessage = styled.p`
  color: #1a1a1a;

  font-size: 18px;
  font-weight: bold;
  margin: 8px 10px;
`
const LabelWrapper = styled.span`
  font-size: 12px;
  margin-bottom: 10px;
  color: #808080;
`
const LabelInfo = styled.h4`
  color: #1a1a1a;
  margin-top: 5px;
  font-size: 14px;
  font-weight: 600;
  font-family: roboto;
`
export const ReviewReportedVideoModal = ({
  data,
  visible,
  onCancel,
  mode,
  refetch,
  selected,
  setSelected,
}) => {
  const [comment, setComment] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setComment('')
  }, [visible])

  const handleRequest = async flag => {
    const proceed = async () => {
      try {
        if (comment === '') {
          notification.warning({
            message: 'Comment is Required',
          })
          return
        }

        let tempData = null
        setLoading(true)

        if (mode === 'multiple') {
          tempData = {
            video_ids: selected,
            status: flag ? 'flagged' : 'active',
            flag_resolved_comment: comment,
          }
        } else {
          tempData = {
            video_ids: data?._id,
            status: flag ? 'flagged' : 'active',
            flag_resolved_comment: comment,
          }
        }

        await VideosService.resolveFlaggedVideo(tempData)

        notification.success({
          message: 'Success!',
          description: `Request ${flag ? 'Video removed' : 'Report ignored'} successfully.`,
        })

        refetch()
      } catch (error) {
        notification.error({
          message: 'Error!',
          description: error?.message || 'Failed to process request.',
        })
      } finally {
        setComment('')
        onCancel()
        setSelected([])
        setLoading(false)
      }
    }

    if (flag) {
      Modal.confirm({
        title: 'Confirm Video Removal',
        content: 'Are you sure you want to remove the reported video?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: proceed,
      })
    } else {
      await proceed()
    }
  }
  return (
    <ReviewStyledModal
      title="Review Reported Video"
      visible={visible}
      onCancel={onCancel}
      closeIcon={<StyledCloseIcon>✖</StyledCloseIcon>}
      centered
      className={mode === 'multiple' ? 'normal-height-modal' : ''}
      footer={
        <FooterButtons>
          <FullWidthButton
            disabled={loading || comment === ""}
            onClick={() => handleRequest(true)}
            type="primary"
            danger
          >
            Remove Video
          </FullWidthButton>
          <FullWidthButton
            disabled={loading || comment === ""}
            onClick={() => handleRequest(false)}
            type="default"
          >
            Ignore Report
          </FullWidthButton>
        </FooterButtons>
      }
    >
      {mode === 'multiple' ? (
        <div className="video-info d-flex justify-content-center  align-items-center p-3">
          <StackPlus size={32} />{' '}
          <VideoSelectionMessage>
            Multiple Videos Selected
          </VideoSelectionMessage>
        </div>
      ) : (
        <>
          <div className="video-info" style={{ padding: '5px 20px' }}>
            <LabelWrapper>Video:</LabelWrapper>
            <div className="d-flex mt-1">
              <div>
                <img
                  src={data?.thumbnail_url}
                  alt="video thumbnail"
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '10px',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div className="ms-3">
                <div className="video-title">{data?.title}</div>
                <div className=" d-flex">
                  <DetailText className="d-flex gap-3">
                    <span>
                      {DateUtility.formatDate(new Date(data?.createdAt))}{' '}
                    </span>
                    <span> {data?.competition_name}</span>
                    <span>
                      {' '}
                      <DotSeparator>•</DotSeparator> Round {data?.round_number}
                    </span>
                  </DetailText>
                </div>
                <div>
                  <StatsContainer className="d-flex justify-content-between mt-2">
                    <StatWrapper>
                      <ThumbsUp size={20} />
                      <BoldSpan>{data?.votes_count} &nbsp; </BoldSpan>
                    </StatWrapper>
                    <StatWrapper>
                      <Eye size={20} />
                      <BoldSpan>{data?.views_count} &nbsp; </BoldSpan>
                    </StatWrapper>
                    <StatWrapper>
                      <ChatCircleText size={20} />
                      <BoldSpan> {data?.comment_count} </BoldSpan>
                    </StatWrapper>
                  </StatsContainer>
                </div>
              </div>
            </div>
          </div>

          <Space
            direction="vertical"
            size="small" // Reduced from "middle" to "small"
            className="mt-1"
            style={{ padding: '0px 20px', width: '100%' }} // Reduced right and left padding
          >
            {/* Creator Section */}
            <div className="d-flex flex-column ">
              <LabelWrapper>Creator:</LabelWrapper>
              <UserAvatarWithName
                id={data?.user?.fid}
                title={data?.user?.name}
                url={data?.user?.image}
              />
            </div>

            {/* Other Details */}
            <div>
              <LabelWrapper>Reason:</LabelWrapper>
              <LabelInfo>{data?.flag_reason || '-'}</LabelInfo>
            </div>
            <div className="d-flex">
              <div className="w-50 pe-2">
                <LabelWrapper>Reported By:</LabelWrapper>
                <LabelInfo>{data?.flagged_by?.name || '-'}</LabelInfo>
              </div>
              <div className="w-50 pe-2">
                <LabelWrapper>Flagged On:</LabelWrapper>
                <LabelInfo>
                  {DateUtility.formatDate(
                    new Date(data?.flagged_on),
                    DateFormat.DD_MM_YYYY_Time,
                  ) || '-'}
                </LabelInfo>
              </div>
            </div>
          </Space>
        </>
      )}
      <hr />
      <Form requiredMark="optional">
        {' '}
        <div className="comment-box " style={{ padding: '5px 20px' }}>
          <Form.Item
            label={
              <span>
                Comment <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="comment"
            rules={[{ required: true, message: 'This field is required' }]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder="Enter your reason to approve or disapprove"
              value={comment}
              onChange={e => setComment(e.target.value)}
              style={{
                backgroundColor: '#fafafa',
                color: '#000',
                padding: '10px 12px', // Top-Bottom: 10px, Left-Right: 12px (default)
              }}
            />
          </Form.Item>
        </div>
      </Form>
    </ReviewStyledModal>
  )
}
